module.exports = __webpack_public_path__ + "static/thumbnail-0609f2954cc279ecadedf41ffdb2234f.png";